import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DigitalMenuApi, FilterDigitalMenuOptions } from 'api';
import { DigitalMenuType } from 'containers/SaleManager/Marketing/WholesaleDigitalMenu/commons';

export const createDigitalMenu = createAsyncThunk(
  'digitalMenu/createDigitalMenu',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneDigitalMenuDetailByAdmin = createAsyncThunk(
  'digitalMenu/findOneDigitalMenuDetailByAdmin',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuApi.findOneDetail(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findDigitalMenuForTableList = createAsyncThunk(
  'digitalMenu/findDigitalMenuForTableList',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findDigitalMenuWholesForTableList = createAsyncThunk(
  'digitalMenu/findDigitalMenuWholesForTableList',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneRetailDigitalMenuForDetail = createAsyncThunk(
  'digitalMenu/findOneRetailDigitalMenuForDetail',
  async (params: { id: string }, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await DigitalMenuApi.findOneRetailDigitalMenuForDetail(
        id
      );
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkDuplicateDigitalMenuShortID = createAsyncThunk(
  'digitalMenu/checkDuplicateDigitalMenuShortID',
  async (
    { id, shortID }: { id: string; shortID: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await DigitalMenuApi.checkDuplicateShortID(id, shortID);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateDigitalMenu = createAsyncThunk(
  'digitalMenu/updateDigitalMenu',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await DigitalMenuApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteDigitalMenu = createAsyncThunk(
  'digitalMenu/deleteDigitalMenu',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterDigitalMenu = createAsyncThunk(
  'digitalMenu/filterDigitalMenu',
  async (option: FilterDigitalMenuOptions, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  reloadFlag: boolean;
  tableList: Array<DigitalMenuType>;
  myList: Array<any>;
  purchaseList: Array<any>;
  purchaseReloadedRow?: any;
  collaboratorList: Array<any>;
  list: Array<any>;
  isLoadingTable: boolean;
  pagination: any;
  savedPagination?: any;
  savedList: Array<any>;
}

const initialState: IState = {
  reloadFlag: false,
  tableList: [],
  myList: [],
  purchaseList: [],
  purchaseReloadedRow: undefined,
  collaboratorList: [],
  list: [],
  isLoadingTable: true,
  pagination: {},
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const digitalMenuSlice = createSlice({
  name: 'digitalMenu',
  initialState,
  reducers: {
    reloadDigitalMenu(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateStatusDigitalMenu(state, { payload }) {
      state.tableList = payload;
    },
    updateSavedPaginationWholesaleDigitalMenu(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListWholesaleDigitalMenu(state, action) {
      state.savedList = action.payload;
    },
    updateSavedPaginationRetailDigitalMenu(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListRetailDigitalMenu(state, action) {
      state.savedList = action.payload;
    },
  },
  extraReducers: build => {
    build.addCase(findDigitalMenuForTableList.pending, (state, action) => {
      if (!state.isLoadingTable) state.isLoadingTable = true;
    });
    build.addCase(
      findDigitalMenuForTableList.fulfilled,
      (state, { payload }: any) => {
        state.tableList = payload.data;
        state.pagination = payload.pagination;
        state.isLoadingTable = false;
      }
    );
  },
});

const { actions, reducer: digitalMenuReducer } = digitalMenuSlice;

export const {
  reloadDigitalMenu,
  updateStatusDigitalMenu,
  updateSavedPaginationWholesaleDigitalMenu,
  updateSavedListWholesaleDigitalMenu,
  updateSavedPaginationRetailDigitalMenu,
  updateSavedListRetailDigitalMenu,
} = actions;

export default digitalMenuReducer;
